let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kvQ8n")).then(() => parcelRequire('30NnA'));